import { render, staticRenderFns } from "./ContactSidebar.vue?vue&type=template&id=7c813d3e&scoped=true"
import script from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContactSidebar.vue?vue&type=style&index=0&id=7c813d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c813d3e",
  null
  
)

export default component.exports